module.exports = __webpack_public_path__ + "img/prize-xsd-dark.52d6582f.png";